"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgCheck = function (props) {
    var color = props.color;
    return (react_1.default.createElement("path", { fill: color, fillRule: "evenodd", d: "M7.65236953,11.5397658 C7.12202341,10.9033505 6.17617636,10.8173644 5.53976101,11.3477105 C4.90334567,11.8780566 4.81735957,12.8239037 5.34770569,13.460319 L7.84770569,16.460319 C8.37587285,17.0941196 9.31673793,17.1824112 9.95359849,16.6579378 L18.4535985,9.65793778 C19.0930864,9.13130065 19.1845701,8.18596949 18.657933,7.54648155 C18.1312958,6.9069936 17.1859647,6.81550994 16.5464767,7.34214707 L9.19765971,13.394114 L7.65236953,11.5397658 Z" }));
};
exports.default = factorySvgIcon_1.default(SvgCheck);
//# sourceMappingURL=SvgCheck.js.map